import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { DirectionService } from '@app/_services/direction.service';
import { fromEvent, Subscription } from 'rxjs';
import { SiteService } from '@app/_services/site.service';
import { ChatWindowComponent } from '../../../../_components/live-chat/chat-window/chat-window.component';
import { MatIconModule } from '@angular/material/icon';
import { BidiModule } from '@angular/cdk/bidi';

@Component({
    selector: 'app-mobile-browsing-controls',
    templateUrl: './mobile-browsing-controls.component.html',
    styleUrls: ['./mobile-browsing-controls.component.scss'],
    standalone: true,
    imports: [BidiModule, MatIconModule, NgIf, ChatWindowComponent]
})
export class MobileBrowsingControlsComponent implements AfterViewInit {
    @ViewChild('browsingControls') private browsingControls: ElementRef;
    clickedElement: Subscription;

    mainIcon: 'more_vert' | 'more_horiz' | 'close' = 'more_horiz';
    isActive: boolean = false;

    constructor(
        public direction: DirectionService,
        private location: Location,
        public siteService: SiteService
    ) {
    }

    ngAfterViewInit(): void {
        this.clickedElement = fromEvent(this.browsingControls.nativeElement, 'click').subscribe(() => {
            this.openMenu();
        });
    }

    ngOnDestroy(): void {
        this.clickedElement.unsubscribe();
    }

    openMenu(): void {
        if (this.isActive) {
            this.mainIcon = 'more_horiz';
        } else {
            this.mainIcon = 'close';
        }

        this.isActive = !this.isActive;
    }

    goBack(): void {
        this.location.back();
    }

    refresh(): void {
        window.location.reload();
    }

    pageTop(): void {
        document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start'
        });
    }

    pageBottom(): void {
        document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'end'
        });
    }
}
